import { render, staticRenderFns } from "./searchScore.vue?vue&type=template&id=66fd5599&scoped=true"
import script from "./searchScore.vue?vue&type=script&lang=js"
export * from "./searchScore.vue?vue&type=script&lang=js"
import style0 from "./searchScore.vue?vue&type=style&index=0&id=66fd5599&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fd5599",
  null
  
)

export default component.exports